import clsx from "clsx";
import Toast from "components/Toast";
import { observer } from "mobx-react-lite";
import React from "react";
import { globalStore } from "store/GlobalStore";

const EditorLayout = (props: {
  header: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}) => {
  const { toastList } = globalStore;

  return (
    <div className="fixed top-0 left-0 w-screen h-screen z-20 bg-gray-100">
      {props.header}
      <div
        className={clsx(
          "grid grid-cols-2 relative min-h-[calc(100vh-57px)]",
          props.className
        )}
      >
        {props.children}
      </div>
      {toastList && <Toast toastList={toastList} />}
    </div>
  );
};

export default observer(EditorLayout);
